import { render, staticRenderFns } from "./contact-us-info.vue?vue&type=template&id=bbca3552&"
import script from "./contact-us-info.vue?vue&type=script&lang=js&"
export * from "./contact-us-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports